import { ModalProps } from "@/Components/UI/Modal";
import ConfirmationModal from "@/Components/UI/Modals/ConfirmationModal";
import { ReactNode } from "react";
import { createRoot } from "react-dom/client";

type PromiseModalProps = Partial<ModalProps> & {
    id: string;
    title: ReactNode;
    content: ReactNode;
    confirmText?: string;
    cancelText?: string;
    dataTestId?: string;
};

export function promiseModal({
    id,
    title,
    content,
    confirmText = "Confirm",
    cancelText = "Cancel",
    dataTestId,
    ...props
}: PromiseModalProps): Promise<boolean> {
    return new Promise((resolve) => {
        const modalRoot = document.createElement("div");
        document.body.appendChild(modalRoot);
        const root = createRoot(modalRoot);

        const cleanup = () => {
            root.unmount();
            modalRoot.remove();
        };

        const handleConfirm = () => {
            cleanup();
            resolve(true);
        };

        const handleCancel = () => {
            cleanup();
            resolve(false);
        };

        root.render(
            <ConfirmationModal
                id={id}
                show={true}
                onClose={handleCancel}
                title={title}
                content={content}
                confirmText={confirmText}
                cancelText={cancelText}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
                showCloseButton={true}
                {...props}
                dataTestId={dataTestId}
            />,
        );
    });
}
